<script>
import { Event } from '@/plugins/bus';

export default {
  computed: {
    unitId() {
      return this.$route.params.unitId;
    },
    querystring() {
      if (!this.params) {
        return '';
      }
      return (
        '?' +
        Object.keys(this.params)
          .filter(key => !!this.params[key])
          .map(key => key + '=' + this.params[key])
          .join('&')
      );
    },
    params() {
      return {
        unitId: this.unitId || ''
      };
    }
  },
  methods: {
    async getVehicleOffRoadHistory(unitId) {
      try {
        this.$wait.start('loading VOR history');
        this.$wait.start('loading data');
        const response = await this.$api.get(`units/${unitId}/vehicle-off-road`);
        return response.data;
      } catch (error) {
        this.$toast.error('There was an error getting VOR history');
        return [];
      } finally {
        this.$wait.end('loading VOR history');
        this.$wait.end('loading data');
      }
    },
    async getVehicleOffRoadActive(unitId) {
      try {
        this.$wait.start('loading VOR active');
        this.$wait.start('loading data');
        const response = await this.$api.get(`units/${unitId}/vehicle-off-road?activeOnly=true`);
        return response.data;
      } catch (error) {
        this.$toast.error('There was an error getting VOR history');
        return [];
      } finally {
        this.$wait.end('loading VOR active');
        this.$wait.end('loading data');
      }
    },
    async updateVehicleOffRoad(unitId, update) {
      try {
        const response = await this.$api.put(`units/${unitId}/vehicle-off-road/${update.id}`, update);
        this.$bus.$emit(Event.VehicleOffRoadUpdated, response.data);
      } catch (err) {
        this.$toast.error(`Could not update VOR`);
      } finally {
        this.$toast.success(`VOR updated`);
      }
    },
    async addVehicleOffRoad(unitId, vehicleOffRoadId, add) {
      try {
        const response = await this.$api.put(`units/${unitId}/vehicle-off-road/${vehicleOffRoadId}`, add);
        this.$bus.$emit(Event.VehicleOffRoadUpdated, response.data);
      } catch (err) {
        this.$toast.error(`Could not add VOR`);
      } finally {
        this.$toast.success(`New VOR added`);
      }
    },
    async getVehicleOffRoadHistoryForReport(unitId, query) {
      let p = {};
      for (let k in query) {
      if (query[k]) {
        p[k] = query[k];
      }
      }

      try {
      this.$wait.start('loading VOR history for report');
      this.$wait.start('loading data');
      const response = await this.$api.get(`units/${unitId}/vehicle-off-road-report?${new URLSearchParams(p).toString()}`);
      return response.data;
      } catch (error) {
      this.$toast.error('There was an error getting VOR history for report');
      return [];
      } finally {
      this.$wait.end('loading VOR history for report');
      this.$wait.end('loading data');
      }
    }
  }
};
</script>
